// extracted by mini-css-extract-plugin
export default {"contentSidebarGrid":"ContentBlock_contentSidebarGrid__oYarz"};